var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraw = function SvgDraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.5 4.1 2.4 2.4-1.415 1.427-2.4-2.4zm-2.823 2.847 2.4 2.4-7.613 7.678A4 4 0 0 0 8.6 15.6c-.516-.516-1.033-.81-1.533-.978zm-9.104 9.456L4.6 19.5l3.097-.974C7.684 17.909 7.603 17.42 7.1 17c-.501-.5-.932-.584-1.527-.597M17.5 2c-.5 0-.9.2-1.3.5L4 14.7c-.1.1-.2.2-.2.4L2 20.9c-.1.5.3 1.1.9 1.1h.3L9 20.2c.1 0 .3-.1.4-.2L21.5 7.8c.7-.7.7-1.8 0-2.5l-2.7-2.7c-.4-.4-.9-.6-1.3-.6",
    clipRule: "evenodd"
  })));
};
export default SvgDraw;